// extracted by mini-css-extract-plugin
export default {"aiFacial":"_1xVaKRQ9-vpVTDx5-eIFbA==","banner":"G2B8mvneWNj3YFytrr3BZg=="};